import { render, staticRenderFns } from "./DashboardPresetDialog.vue?vue&type=template&id=6d14afc1&scoped=true"
import script from "./DashboardPresetDialog.vue?vue&type=script&lang=js"
export * from "./DashboardPresetDialog.vue?vue&type=script&lang=js"
import style0 from "./DashboardPresetDialog.vue?vue&type=style&index=0&id=6d14afc1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d14afc1",
  null
  
)

export default component.exports